import { AlertTriangle, Bell, Calendar, CheckCircle, Clock, CreditCard, FileText, Hash, Mail, RefreshCw, Shield, Slash, Volume2, XCircle } from 'react-feather'

// One icon and one tone per inbox type (issues #123, #127). Keep this file identical
// in both portals and in step with notificationIcon() / notificationTone() in the
// mobile app (src/lib/notify.ts, FontAwesome equivalents).
const KINDS = {
  OFFENCE_RECORDED: { icon: AlertTriangle, tone: 'danger' },
  OFFENCE_OVERDUE: { icon: Clock, tone: 'danger' },
  OFFENCE_PAID: { icon: CheckCircle, tone: 'success' },
  OFFENCE_CANCELLED: { icon: XCircle, tone: 'neutral' },
  LICENCE_ACTION: { icon: CreditCard, tone: 'warning' },
  RENEWAL_DUE: { icon: RefreshCw, tone: 'warning' },
  VEHICLE_NUMBER_BOOKING_PAYMENT: { icon: Hash, tone: 'warning' },
  ANNOUNCEMENT: { icon: Volume2, tone: 'neutral' },
  NEWS: { icon: FileText, tone: 'neutral' },
  OFFICER_MESSAGE: { icon: Mail, tone: 'neutral' }
}

const UNKNOWN = { icon: Bell, tone: 'neutral' }

// What a notice is about (announcement `topic`, sent as `data.topic` in the inbox).
export const TOPICS = [
  { value: 'general', label: 'General', icon: Volume2, tone: 'neutral' },
  { value: 'disruption', label: 'Service disruption', icon: Slash, tone: 'warning' },
  { value: 'road_safety', label: 'Road safety', icon: Shield, tone: 'neutral' },
  { value: 'closure', label: 'Office closure or holiday', icon: Calendar, tone: 'warning' }
]

// A topic only counts on an ANNOUNCEMENT; NEWS with a topic is still NEWS.
const kindOf = (type, data) => (type === 'ANNOUNCEMENT' && TOPICS.find((t) => t.value === data?.topic)) || KINDS[type] || UNKNOWN

/** The icon component for an inbox item; a bell for anything unknown. */
export const notificationIcon = (type, data) => kindOf(type, data).icon

/** danger | success | warning | neutral: the tint of the item's icon circle. */
export const notificationTone = (type, data) => kindOf(type, data).tone

/** The Vuexy Avatar colour for a tone: `<Avatar color={toneColor(tone)} icon={...} />`. */
export const toneColor = (tone) => (tone === 'neutral' ? 'light-secondary' : `light-${tone}`)

/** An announcement row (admin list and form) as its inbox type and data. */
export const announcementInbox = (row) => (row.kind === 'news' ? ['NEWS', null] : ['ANNOUNCEMENT', { topic: row.topic }])
